import type { PersonalViewState } from "../lib/usePersonalView";

/** Remembering a selection is silent; only problems and invalid drafts need words (#534). */
export function PersonalViewStatus({ view, draftMessage }: { view: PersonalViewState; draftMessage?: string }) {
  const message = draftMessage ?? view.error;
  if (!message) return null;
  return <div className="text-xs text-slate-600" aria-label="Persönliche Ansicht">
      <p role={view.error && !draftMessage ? "alert" : "status"}>{message}</p>
      {view.error && !draftMessage ? <button type="button" className="mt-1 font-medium text-emerald-800 underline underline-offset-2" onClick={() => void view.retry()}>{view.retryLabel}</button> : null}
    </div>;
}

/**
 * Zurück zur Standardansicht als schlichter Textlink (#630): sitzt in der
 * Kopfzeile oder Filterleiste der Seite, nie in einer eigenen Zeile.
 */
export function PersonalViewReset({ view, defaultLabel, className = "" }: { view: PersonalViewState; defaultLabel: string; className?: string }) {
  if (!view.customized) return null;
  return <button type="button" disabled={!view.ready || view.pending} onClick={view.reset}
    className={`inline-flex h-9 shrink-0 items-center text-sm font-medium text-emerald-700 hover:underline disabled:opacity-50 ${className}`}
    title={`Standardansicht: ${defaultLabel}`}>Filter zurücksetzen</button>;
}

/** Fehlermeldungen der persönlichen Ansicht; den Rücksetz-Link setzt die Seite selbst (PersonalViewReset). */
export default function PersonalViewNotice({ view, defaultLabel, draftMessage, withReset = false, className = "mb-4 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 text-xs text-slate-600" }: { view: PersonalViewState; defaultLabel: string; draftMessage?: string; withReset?: boolean; className?: string }) {
  const hasMessage = Boolean(draftMessage ?? view.error);
  if (!hasMessage && !(withReset && view.customized)) return null;
  return <div className={className}>
    <PersonalViewStatus view={view} draftMessage={draftMessage} />
    {withReset ? <PersonalViewReset view={view} defaultLabel={defaultLabel} className="ml-auto" /> : null}
  </div>;
}
